<div class="content-box flex-column d-flex py-2 flex-md-row">
  <span class="align-self-center w-100">{{displayedTextDetails?.mainBlockText}}</span>
  <button class="button button-sm button-primary align-self-center flex-shrink-0"
          yp-e2e-id="info-block-button"
          [appButtonLoader]="disableButton"
          (click)="emitButtonClicked()"
          type="button">{{displayedTextDetails?.buttonText}}</button>
</div>
